import React from 'react';

interface SkipLinkProps {
  targetId?: string;
  label?: string;
}

const SkipLink: React.FC<SkipLinkProps> = ({
  targetId = 'main-content',
  label = 'Skip to main content',
}) => (
  <a
    href={`#${targetId}`}
    className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-stone-900 focus:text-white focus:px-6 focus:py-3 focus:text-xs focus:font-bold focus:uppercase focus:tracking-widest focus:shadow-2xl"
  >
    {label}
  </a>
);

export default SkipLink;
